import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { BasicForm } from "@components/shared";

export default function ManagerForm({
  id = null,
  communicationEmail = "",
  email = "",
  firstName = "",
  lastName = "",
  mfa = false,
  organizationId,
  locationId,
  onSuccess = () => { },
}) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  function onSubmit(formData) {
    setLoading(true);

    if (id) return onUpdate(formData);

    return onCreate(formData);
  }

  function onCreate(formData) {
    const req = {
      ...formData,
    };

    if (locationId) req.location_id = locationId;
    if (organizationId) req.organization_id = organizationId;

    axios
      .post(`/managers/`, req)
      .then(() => setLoading(false))
      .then(() => toast.success(t("common:created") + "!"))
      .then(() => onSuccess())
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  function onUpdate(formData) {
    const req = {
      ...formData,
      manager_id: id,
    };

    axios
      .put(`/managers/${id}/`, req)
      .then(() => setLoading(false))
      .then(() => toast.success(t("common:updated") + "!"))
      .then(() => onSuccess())
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "first_name",
      label: t("common:first_name"),
      initialValue: firstName,
      required: true,
      schema: () =>
        Yup.string()
          .max(50, t("validation:too_long"))
          .required(t("validation:required")),
    },
    {
      name: "last_name",
      label: t("common:last_name"),
      initialValue: lastName,
      required: true,
      schema: () =>
        Yup.string()
          .max(50, t("validation:too_long"))
          .required(t("validation:required")),
    },
    {
      name: "email",
      label: t("common:email"),
      initialValue: email,
      required: true,
      // disabled: id && !email,
      schema: () =>
        Yup.string()
          .max(100, t("validation:too_long"))
          .email(t("validation:email_invalid"))
          .required(t("validation:required")),
    },
    // {
    //   name: "mfa",
    //   label: "Multi-Factor Authentication",
    //   initialValue: mfa,
    //   required: false,
    //   schema: () => null,
    //   toggle: true,
    // },
  ]
    .filter((f) =>
      id
        ? !email
          ? !["email"].includes(f.name)
          : true
        : !["communication_email"].includes(f.name)
    )
    .filter((f) => (email ? !["communication_email"].includes(f.name) : true));

  return (
    <BasicForm
      buttonProps={{
        fullWidth: !id ? true : false,
      }}
      loading={loading}
      onSubmit={onSubmit}
      fields={fields}
    />
  );
}
